import { Badge } from '@/components/Badge/Badge';
import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import {
  getFeedbackSourceName,
  getSourceIcon,
  type SOURCE_TYPE,
} from '@/types/feedbackConst';

import { IntegrationItemStyle } from '../../IntergrationStyles';
import { INTEGRATION_STATUS, IntegrationStatusMap } from '../../types';

export const ScrapingSourceItem = ({
  sourceType,
  desc,
  onClick,
  status,
}: {
  sourceType: SOURCE_TYPE;
  desc?: string;
  status: INTEGRATION_STATUS;
  onClick: (e: React.MouseEvent) => void;
}) => {
  const name = getFeedbackSourceName(sourceType);
  const icon = getSourceIcon(sourceType, 24);

  if (status === INTEGRATION_STATUS.DISABLE) {
    return null;
  }

  return (
    <IntegrationItemStyle
      a="center"
      j="space-between"
      isIntegrated={false}
      style={{
        cursor: 'unset',
      }}
    >
      <Flex a="center" g={12}>
        <Flex className="logo-area">
          {icon}
          <div className="flex gap-2 items-center">
            <Typo type="label2" weight="sb" className="text-gray-800">
              {name}
            </Typo>
            {status !== INTEGRATION_STATUS.HEALTHY && (
              <Badge variant="warning">
                {IntegrationStatusMap.get(status)}
              </Badge>
            )}
          </div>
        </Flex>
        <div className="desc-area">
          <Typo type="body2" className="text-gray-800">
            {desc || name}
          </Typo>
        </div>
      </Flex>
      <Button variant="outlined" onClick={onClick} sizeType="s">
        Create scraping job
      </Button>
    </IntegrationItemStyle>
  );
};
